import styled         from 'styled-components';
import { Box } from '@mui/material';
import { extraColor } from '@styles/muiTheme';

export const BoxWrapper = styled.div`
  width: 100%;
  height: 88vh;
  display: flex;
  justify-content: center;
`;

export const Main = styled.main<{ open: boolean; openViaButton: boolean }>`
  flex: 1;
  margin-left: ${({ open, openViaButton, theme }) => (openViaButton ? theme.drawerWidth : open ? theme.drawerWidth : '1px')};
  flex-grow: 1;
  position: relative;
  min-width: ${({ open }) => (open ? '900px' : 'auto')};
  transition:
    margin-left 0.3s ease,
    ${({ theme, open }) =>
      theme.transitions.create('margin', {
        easing: theme.transitions.easing[open ? 'easeOut' : 'sharp'],
        duration: theme.transitions.duration[open ? 'enteringScreen' : 'leavingScreen'],
      })};
`;

export const Divider = styled.div`
  z-index: 1;
  height: 30px;
  margin-top: -20px;
  position: relative;
  background: transparent linear-gradient(0deg, ${extraColor.palette.grey.dark} 0%, ${extraColor.palette.transparent.light} 100%) 0% 0% no-repeat padding-box;
`;

export const TabOutletWrapper = styled.div<{ contentHeight: number }>`
  width: 100%;
  height: calc(100vh - ${({ contentHeight }) => contentHeight}px);
  overflow: auto;
  display: flex;
  flex-direction: column;
`;

export const SidebarWrapper = styled.div<{ openViaButton: boolean }>`
  width: ${({ openViaButton, theme }) => (openViaButton ? theme.drawerWidth : '1px')};
  height: 100vh;
  transition: width 0.3s ease;
  position: absolute;
  z-index: 5;
`;

export const UserWithoutRolesWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 88vh; 
`;